<div class="system-page">
  @if (actionsEnabled) {
    <div class="system-page__group">
      <h3 class="subheading">Other actions</h3>
      <div class="module">
        <a class="btn btn--basic" href="javascript:void(0)" (click)="onClearCache()">Clear metadata cache</a>
        <a class="btn btn--danger" href="javascript:void(0)" (click)="requestConfirm('deleteData')">Delete all data</a>
        <a class="btn btn--danger" href="javascript:void(0)" (click)="requestConfirm('deleteTenant')">Delete tenant</a>
        <a class="btn btn--basic" href="javascript:void(0)" (click)="requestConfirm('rebuild')">Rebuild</a>
        <a class="btn btn--basic" href="javascript:void(0)" (click)="onLoadAssets()">Load assets</a>
        <a class="btn btn--basic" href="javascript:void(0)" (click)="onLoadDefaultData()">Load default data</a>
        <a class="btn btn--basic" href="javascript:void(0)" (click)="onOpenRecalculate()">Recalculate</a>
        <a class="btn btn--basic" routerLink="../modules">Module Management</a><br>
        <a class="btn btn--basic" [routerLink]="['/apidocs', tenantCode]">API documentation</a>
        <a class="btn btn--basic" [routerLink]="['/', tenantCode, 'system', 'status']">Status</a>
        <a class="btn btn--basic" [routerLink]="['/', tenantCode, 'system', 'model']">Model status</a>
        <a class="btn btn--basic" [routerLink]="['/system', tenantCode, 'serviceCallLogs']">Usage</a>
        <a class="btn btn--basic" [routerLink]="['/system', tenantCode, 'logEntries']">Log Entries</a>
        <a class="btn btn--basic" [routerLink]="['/system', tenantCode, 'userProfiles']">User Profiles</a>
        <a class="btn btn--basic" [routerLink]="['/system', tenantCode, 'invites']">Invites</a>
        <a class="btn btn--basic" [routerLink]="['/system', tenantCode, 'systemSettings']">System Values</a>
        <a class="btn btn--basic" [routerLink]="['/system', tenantCode, 'secretValues']">Secret Values</a>
      </div>
    </div>
  }

  @if (showRecalculate) {
    <div class="system-page__group">
      <h3 class="subheading">Recalculate</h3>
      <label class="system-page__recalculate-toggle">
        <input type="checkbox" [checked]="showAllTypes" (change)="onToggleAllTypes()">
        Show all types
      </label>
      @if (typesLoading) {
        <div class="system-page__recalculate-loading">Loading types…</div>
      }
      @if (!typesLoading) {
        <div class="system-page__recalculate-list">
          @for (type of types; track type) {
            <div class="system-page__recalculate-row">
              <span class="system-page__recalculate-name">{{ type.name }}</span>
              @if (recalculateStates[type.pluralName] === 'done') {
                <span class="system-page__recalculate-status system-page__recalculate-status--done">Gestart</span>
              }
              @if (recalculateStates[type.pluralName] === 'error') {
                <span class="system-page__recalculate-status system-page__recalculate-status--error">Fout</span>
              }
              <a
                class="btn btn--basic"
                href="javascript:void(0)"
                [class.btn--disabled]="recalculateStates[type.pluralName] === 'loading' || recalculateStates[type.pluralName] === 'done'"
                (click)="onRecalculate(type)">
                {{ recalculateStates[type.pluralName] === 'loading' ? 'Bezig…' : 'Recalculate' }}
              </a>
              @if (syncStates[type.pluralName] === 'done') {
                <span class="system-page__recalculate-status system-page__recalculate-status--done">Gestart</span>
              }
              @if (syncStates[type.pluralName] === 'error') {
                <span class="system-page__recalculate-status system-page__recalculate-status--error">Fout</span>
              }
              <a
                class="btn btn--basic"
                href="javascript:void(0)"
                [class.btn--disabled]="syncStates[type.pluralName] === 'loading' || syncStates[type.pluralName] === 'done'"
                (click)="onSync(type)">
                {{ syncStates[type.pluralName] === 'loading' ? 'Bezig…' : 'Sync' }}
              </a>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (pendingAction) {
    <div class="system-page__confirm">
      <p class="system-page__confirm-text">
        @if (pendingAction === 'deleteTenant') {
          <strong>Verwijder de gehele werkruimte inclusief alle data.</strong>
        }
        @if (pendingAction === 'deleteData') {
          <strong>Verwijder alle data van de werkruimte.</strong>
        }
        @if (pendingAction === 'rebuild') {
          <strong>Herbouw de werkruimte. Dit is een zware operatie.</strong>
        }
        Typ de naam van de werkruimte om te bevestigen: <em>{{ tenantName }}</em>
      </p>
      <input class="system-page__confirm-input" type="text" [(ngModel)]="confirmInput" [placeholder]="tenantName" autocomplete="off">
      <div class="system-page__confirm-actions">
        <a class="btn btn--basic" href="javascript:void(0)" (click)="cancelConfirm()">Annuleren</a>
        <a class="btn btn--danger" href="javascript:void(0)" [class.btn--disabled]="!confirmValid" (click)="confirm()">Bevestigen</a>
      </div>
    </div>
  }
</div>
